export enum AdminMenu {
  admin = 'administración',
  student = 'alumnos',
  professors = 'profesores',
  bono = 'bono',
}

export interface MenuItems {
  label: string
  description: string
}

export const AdminStudentMenu: Record<string, MenuItems> = {
  bonos: { label: 'historial-de-bonos', description: 'Historial de Bonos' },
  courses: { label: 'historial-de-cursos', description: 'Historial de Cursos' },
  profile: { label: 'perfil', description: 'Perfil' },
}

export const AdminProfessorMenu: Record<string, MenuItems> = {
  activity: {
    label: 'historial-actividades',
    description: 'Historial de Actividades',
  },
  shared: {
    label: 'procesos-compartidos',
    description: 'Procesos Compartidos',
  },
  profile: { label: 'perfil', description: 'Perfil' },
}

export const AdminBonusMenu = [
  'Bonos vencidos',
  'Bonos que le falten 1 clase',
  'Deudores',
  'Alumnos Inactivos',
]

export enum UserType {
  admin = 'Administrador',
  student = 'Alumno',
  professor = 'Profesor',
}

export enum Experience {
  beginner = 'Principiante',
  intermediate = 'Intermedio',
  profesional = 'Profesional',
}

export const listHeads = {
  due: ['Alumno', 'Bono activo', 'Asistencia', ' '],
  lastClass: ['Alumno', 'Clases totales', 'Asistencia', 'Vencimiento'],
  debtors: ['Alumno', 'Debe'],
  inactiveStudents: [
    'Alumno',
    'Bono activo',
    'Asistencia',
    'Vencimiento',
    'Ultima Clase',
  ],
}

export enum URLNavigation {
  DASHBOARD = '/',
  PROFILE = '/perfil',
  STUDENTS = '/bitacoras',
  LINKS = '/links',
  STUDENT_PROFILE = '/perfil-alumno',
  CHAT = '/chat',
  ROUTINE = '/rutina',
  ROUTE = '/ruta-formacion',
  OPINION_FORM = '/formulario-opinion',
}

export const ProfesorStudentMenu: Record<string, MenuItems> = {
  logs: { label: 'bitacoras', description: 'Bitácoras' },
  links: { label: 'links', description: 'Grabaciones' },
  routine: { label: 'rutina', description: 'R. de entrenamiento' },
  chat: { label: 'chat', description: 'Chat' },
  profile: { label: 'perfil-alumno', description: 'Perfil Alumno' },
}

export const StudentMenu: Record<string, MenuItems> = {
  logs: { label: 'bitacoras', description: 'Bitácoras' },
  routine: { label: 'rutina', description: 'R. de entrenamiento' },
  route: { label: 'ruta-formacion', description: 'Ruta para formación vocal' },
  chat: { label: 'chat', description: 'Chat' },
  professorProfile: { label: 'profesor', description: 'Perfil Profesor' },
}

export enum ChallengeStatus {
  ACTIVE = 'active',
  UPCOMING = 'upcoming',
  ENDED = 'ended',
}
